import { render } from "./Row.vue?vue&type=template&id=36e6b088&scoped=true&ts=true"
import script from "./Row.vue?vue&type=script&lang=ts"
export * from "./Row.vue?vue&type=script&lang=ts"

import "./Row.vue?vue&type=style&index=0&id=36e6b088&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e6b088"]])

export default __exports__